import { Button, Row } from "antd";
import React from "react";

const Index = (props) => {

  const { btnText, onCreate } = props;

  return (
    <Row>
      <Button type="primary" className='btn-create' onClick={()=>onCreate()}>
        + {btnText}
      </Button>
    </Row>
  );
};

export default Index;
